<template>
	<div class="main" v-title data-title="零部件个人中心">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">网站公告</h1>
					</div>
				</div>
				<div class="formWBase">
					<div class="list-item mt20" v-for="(item,index) in noticelist">
						<div class="noticeD">
							<el-link :underline="false" @click="noticeInfo(item.id)">{{item.title}}</el-link><span class="fr">{{item.create_time}}</span>
						</div>
					</div>
					<div class="block pdb10 mt40" style="float: right">
						<el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[2, 20, 30, 40]"
						 :page-size="100" layout="prev, pager, next,sizes,total" :total='total'>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				total: 1,
				pcount: '2', //每页多少条
				page: 1, //当前页码数
				noticelist: [],
			};
		},
		created() {
			this.handnoticelist();
		},
		methods: {
			//点击第几页
			handleCurrentChange(val) {
				this.page = val;
				this.handnoticelist();
			},
			handDu(type, id) {
				this.$postcn('tongji/signSystemNotification', {
					id: id,
					type: 'all',
				}, this).then((res) => {
					if (res.data.code == 200) {
						this.handnoticelist();
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			},
			noticeInfo(id){
				let routeData = this.$router.resolve({
					name: "ggnotice",
					query: {
						goodsid: id
					}
				})
				window.open(routeData.href, '_blank');
			},
			handnoticelist() {
				this.$postcn('tongji/homeAnnouncement', {
					p: this.page, //第几页
					pcount: this.pcount, //一页显示多少条
				}, this).then((res) => {
					if (res.data.code == 200 && res.data.code!=-4004) {
						this.noticelist = res.data.data.data
					} else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}else{
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			},
		}
	}
</script>

<style scoped>
	.list-item .noticeD {
		position: relative;
		min-height: 14px;
		padding: 0px 20px;
		line-height: 15px;
		color: #999;
		font-size: 12px;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-divider {
		margin: 12px 0px;
	}
	.noticeD .el-link.el-link--default:hover{
		color: #005dbe;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/wzgg.vue